/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../blocks/blocks.js';
$['__chunk_blocks'] = exports;
